import * as React from 'react'
import { Typography } from 'antd'
import { CaretDownOutlined, CaretUpOutlined } from '@ant-design/icons'
import { useState } from 'react'

const { Paragraph } = Typography

interface Props {
    title: string
    text: string
}

export default function ExpandedText({ text, title }: Props) {
    const [allowExpand, setAllowExpand] = useState<boolean>(false)

    const [expanded, setExpanded] = useState<boolean>(false)
    const [counter, setCounter] = useState<number>(0)
    const expandableText = (
        <Paragraph
            style={{ marginBottom: '0.6em' }}
            onClick={() => {
                if (allowExpand) {
                    setCounter(counter + 1)
                    setExpanded(true)
                }
            }}
            key={counter}
            className="text-justify"
            ellipsis={{
                rows: 3,
                expandable: true,
                symbol: <CaretDownOutlined style={{ color: 'red' }} rev={undefined} />,
                onEllipsis: () => {
                    setAllowExpand(true)
                },
            }}
        >
            <b>{title}: </b> {text}
        </Paragraph>
    )
    return (
        <>
            {!expanded ? (
                expandableText
            ) : (
                <Paragraph
                    style={{ marginBottom: '0.6em' }}
                    className="text-justify"
                    onClick={() => {
                        setCounter(counter + 1)
                        setExpanded(false)
                    }}
                >
                    <b>{title}: </b> {text}
                    <CaretUpOutlined style={{ color: 'red' }} color="primary" rev={undefined} />
                </Paragraph>
            )}
        </>
    )
}
